'use strict';


export default function() {
	return {
		require: '^brgSlideGroup',
		link: postLink,
		scope: {
			slide: '@brgSlideSelect'
		},
	};

	function postLink(scope, element, attrs, group) {
		element.on('click', function() {
			if (!element.attr('disabled')) group.select(scope.slide);
		});
	}
}
